import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';

function DataSnackbar({ selectedFeatureData }) {

    const [relevantData, setRelevantData] = useState({"type": "", "name": "", "params": {}});
    const [open, setOpen] = useState(false);

    const onClose = () => {
        if (selectedFeatureData){
            setOpen(true);
        } else {
            setOpen(false);
        }
    }

    const closeSnackbar = () => {
        setOpen(false);
    };

    // This opens the Snackbar when a subcatchment/outfall is clicked on
    useEffect(() => {
        if (selectedFeatureData) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [selectedFeatureData]);

    // This function returns a grade based on the decay constant
    const getDecayConstantGrade = (decayConstant) => {
        if (decayConstant < -0.26 ) {
            return 'Fastest'; // Fastest
        } else if (decayConstant < -0.22) {
            return 'Fast'; // Fast
        } else if (decayConstant < -0.18) {
            return 'Good'; // Good
        } else if (decayConstant < -0.12 ) {
            return 'Average'; // Average
        } else if (decayConstant < -0.10 ) {
            return 'Below Average'; // Below Average
        } else if (decayConstant < -0.06 ) {
            return 'Slow'; // Slow
        } else if (decayConstant < 0 ) {
            return 'Very Slow'; // Very Slow
        } else {
            return 'Unknown';
        }
    };

    // This sets the relevant data when the selected feature changes
    useEffect(() => {
        if (selectedFeatureData.IMPERV) {
            setRelevantData({
                "type": "Subcatchment",
                "name": selectedFeatureData.NAME,
                "params" : {
                    "Area": selectedFeatureData.AREA,
                    "Percent Impervious": selectedFeatureData.IMPERV,
                    "Elevation": selectedFeatureData.WTELEV,
                    "Area": `${selectedFeatureData.AREA} acres`,
                    "Percent Impervious": `${selectedFeatureData.IMPERV}%`,
                    "Elevation": `${selectedFeatureData.WTELEV} ft`,
                    "Soil Type": selectedFeatureData.AQUIFER,
                    "Est. Drainage Speed": getDecayConstantGrade(selectedFeatureData.DECAY_CONSTANT_ESTIMATE),
                    "Tags": selectedFeatureData.TAG,
                }
            });
        } else if (selectedFeatureData.RIMELEV) {
            setRelevantData({
                "type": "Outfall",
                "name": selectedFeatureData.NAME,
                "params": {
                    "Rim Elevation": `${selectedFeatureData.RIMELEV} ft`,
                    "Tags": selectedFeatureData.TAG,
                    "Description": selectedFeatureData.DESCRIPT,
                }
            }); 
        };
    }, [selectedFeatureData]);

    return (
        <Snackbar
            open={open}
            sx = {{opacity: 0.9}}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={null}  // Keeps the Snackbar open until explicitly closed
        >
            <Alert
                severity="info"
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={closeSnackbar}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{
                    width: '100%',
                    whiteSpace: 'pre-line', // Ensures the message respects line breaks
                }}
            >
                <strong>{relevantData.type}</strong>: {relevantData.name}
                {Object.entries(relevantData.params).map(([key, value]) => (
                    <div key={key}>
                        <strong>{key}</strong>: {value}
                    </div>
                ))}
            </Alert>
        </Snackbar>
    );
}

export default DataSnackbar;